import useNotifications from "@lib/user/useNotifications";
import { NotificationsContext } from "@lib/notifications/NotificationsContext";

export default function NotificationsProvider({ children }) {
  const { notifications, isFetching, dismiss } = useNotifications();

  return (
    <NotificationsContext.Provider value={{ notifications, isFetching, dismiss }}>
      {children}
    </NotificationsContext.Provider>
  );
}
